<!-- Dispute Resolution -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-gavel"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Dispute Resolution</h1>
        <p class="page-description">Manage and resolve order disputes</p>
      </div>
    </div>
    <div class="header-actions">
      <div class="stats-badge">
        <i class="fas fa-database me-1"></i>
        {{ disputes?.length || 0 }} Total Disputes
      </div>
    </div>
  </div>
</div>

<!-- Filters -->
<div class="filters-panel">
  <div class="filter-group">
    <div ngbDropdown class="d-inline-block" container="body">
      <button type="button" class="btn btn-outline-secondary" id="dropdownBasic1" ngbDropdownToggle>
        <i class="fas fa-calendar-alt me-2"></i>Filter by Date
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button ngbDropdownItem>Today</button>
        <button ngbDropdownItem>This week</button>
        <button ngbDropdownItem>This Month</button>
        <button ngbDropdownItem>Custom</button>
      </div>
    </div>

    <div ngbDropdown class="d-inline-block" container="body">
      <button type="button" class="btn btn-outline-secondary" id="dropdownBasic1" ngbDropdownToggle>
        <i class="fas fa-filter me-2"></i>Filter by Status
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button ngbDropdownItem>Today</button>
        <button ngbDropdownItem>This week</button>
        <button ngbDropdownItem>This Month</button>
        <button ngbDropdownItem>Custom</button>
      </div>
    </div>
  </div>
</div>

<!-- Disputes Table -->
<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <div class="title-icon">
        <i class="fas fa-list-alt"></i>
      </div>
      <div class="title-content">
        <div class="title-text">Disputes</div>
        <div class="title-subtitle">All order dispute records</div>
      </div>
    </div>
  </div>

  <div class="panel-body">
    <div class="table-container">
      <table class="table align-middle">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Waiter in Charge</th>
            <th>Reason</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (item of disputes; track $index) {
          <tr>
            <td>
              <span class="fw-semibold">{{ item.order?.uid }}</span>
            </td>
            <td>{{ item?.order?.waiter?.name }}</td>
            <td>{{ item.reason }}</td>
            <td>
              @if (item.status == 'pending') {
              <span class="badge badge-dot badge-soft-danger">Unresolved</span>
              }@else {
              <span class="badge badge-dot badge-soft-success">Resolved</span>
              }
            </td>
            <td>
              <button class="btn btn-sm btn-outline-secondary" (click)="orderDetails(item.id)">
                <i class="fas fa-eye me-1"></i>Order Details
              </button>
            </td>
          </tr>
          }
          @empty {
          <tr>
            <td colspan="5">
              <div class="empty-state">
                <div class="empty-icon">
                  <i class="fas fa-inbox fa-3x"></i>
                </div>
                <div class="empty-content">
                  <h5>No Disputes Found</h5>
                  <p>There are currently no disputes to display. Disputes will appear here when they are reported.</p>
                </div>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
